import styled from 'styled-components';
import { Box } from '../../ui-kit';

// Cart Container
export const CartCustomContainer = styled(Box)`
  position: relative;
  max-width: 46px;
  max-height: 46px;
  margin: 0 auto;
`;
